import React from 'react'
import { DropTarget } from 'react-dnd'
import GovEnrolmentsView from './views'
import { fetchWithRetry } from '../../../authorisation'
import { apiEndpointGovEnrolments } from './index'

export const dropCallbacks = ({
  child_id,
  gov_id,
  name,
  associateRecords,
  droppedComponent,
  dropZone
}) => {


  dropZone.mergePending({name})
  droppedComponent.mergePending()

  return associateRecords({ child_id, gov_id })
    .then(
      () => {
        dropZone.mergeCompleted()
        droppedComponent.mergeCompleted()
      }
    )
    .catch(
      () => {
        dropZone.mergeFailed()
        droppedComponent.mergeFailed()
      }
    )
}

const fetchAssociateRecords = ({ child_id, gov_id, jwt }) => dispatch =>
  fetchWithRetry(
    process.env.REACT_APP_API_HOST +
      `/api/children/${child_id}/gov-enrolments/${gov_id}`,
    {
      token: jwt,
      method: "POST",
      jsonAPI: true,
    },
    dispatch,
  )

const associate = ({
  child_id,
  gov_id,
  jwt,
  dispatchAction,
  refresh_ccms_gov_enrolments,
  child,
}) =>
  fetchAssociateRecords({
    child_id,
    gov_id,
    jwt,
  })(dispatchAction).then(
    response =>
      response.status === 200
        ? refresh_ccms_gov_enrolments(apiEndpointGovEnrolments({ child }))
        : Promise.reject("Unable to merge")
  )


export const dropTargetCallbacks = {
  drop(props, monitor, dropZone) {
    const droppedComponent = monitor.getItem()

    if (droppedComponent) {
      const child_id = props.child.id
      const gov_id = droppedComponent.id
      const name = droppedComponent.name
      const associateRecords = () =>
        associate({
          ...props,
          child_id,
          gov_id,
          child: props.child,
        })

      dropCallbacks({
        child_id,
        gov_id,
        name,
        associateRecords,
        dropZone,
        droppedComponent
      })

      return {
        gov_id
      }
    }
  }
}

export const RenderGovEnrolments = DropTarget(
  'ccms_enrolment',
  dropTargetCallbacks,
  (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  }),
)(GovEnrolmentsView)

export default props =>
  <RenderGovEnrolments {...props} {...props.ccms_gov_enrolments} />



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccms-gov-enrolments/ccms-gov-enrolments.js